import { Grid, IconButton, Tooltip } from '@mui/material'
import { Stepper } from 'react-form-stepper'
import { useCallback, useEffect, useState } from 'react'
import { MdAdd, MdArrowBack } from 'react-icons/md'
import Programa from '../../../components/Programa/Programa'
import { metodoPrograma } from '../../../components/api'
import Edicao from './Edicao'

const AutoAgendamentoOnline = () => {
  const [localAtendimento, setLocalAtendimento] = useState([])
  const [tela, setTela] = useState('lista')
  const [ferramentas, setFerramentas] = useState()
  const [dados, setDados] = useState(null)

  const getList = useCallback(() => {
    metodoPrograma('listaLocalAtendimento', {}).then((res) => {
      if (res.status) {
        setLocalAtendimento(res.lista)
      }
    })
  }, [])

  const voltar = () => {
    setTela('lista')
    setDados(undefined)
    getList()
  }

  useEffect(() => {
    switch (tela) {
      case 'lista':
        setFerramentas(
          <Tooltip title="Adicionar">
            <IconButton onClick={() => setTela('opcoes')}>
              <MdAdd />
            </IconButton>
          </Tooltip>,
        )
        break
      case 'opcoes':
        setFerramentas(
          <Tooltip title="Voltar">
            <IconButton onClick={voltar}>
              <MdArrowBack />
            </IconButton>
          </Tooltip>,
        )
        break
      default:
        break
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tela])

  useEffect(() => {
    if (localAtendimento) {
      getList()
    }
  }, [localAtendimento, getList])

  return (
    <Programa codigo="CtrlAutoAgendamento" ferramentas={ferramentas}>
      {tela === 'lista' ? (
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Stepper
              steps={[
                { label: 'Local de Atendimento' },
                { label: 'Especialidade' },
                { label: 'Médico' },
                { label: 'Turno' },
                { label: 'Horário' },
                { label: 'Agendamento' },
              ]}
              activeStep={0}
              connectorStyleConfig={{ activeColor: '#4e85bf' }}
            />
          </Grid>
        </Grid>
      ) : (
        <Edicao {...{ dados, voltar }} />
      )}
    </Programa>
  )
}

export default AutoAgendamentoOnline
